import { useState, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, CollapseWithIcon } from 'shared/ui'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import { type Integration } from 'entities/Integrations'
import { useIntegrationStoreMemo } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import sharedStyles from 'pages/settings/pages/integrations/pages/integrationSettings/ui/styles.module.scss'
import { IntegrationAgentforceSettingsStore } from '../store/IntegrationAgentforceSettingsStore'
import styles from './styles.module.scss'

type IIntegrationAgentforceSettingsProps = {
  integration: Integration
}

export const IntegrationAgentforceSettings: FC<IIntegrationAgentforceSettingsProps> = observer(
  ({ integration }) => {
    const { packageType, setPackageType, selectItems, installUrl } = useIntegrationStoreMemo(
      IntegrationAgentforceSettingsStore,
      integration
    )
    const [installationOpen, setInstallationOpen] = useState(true)

    return (
      <div>
        <CollapseWithIcon
          opened={installationOpen}
          onClick={() => setInstallationOpen((prev) => !prev)}
          icon={'settingsOutline'}
          title={'Installation'}
          headerClassName={sharedStyles.collapseWithIcon}
        >
          <div className={styles.root}>
            <TitledRow title={'Select your package'}>
              <SelectField
                className={styles.select}
                withSearch={false}
                value={packageType}
                setValue={setPackageType}
                items={selectItems}
                dropdownProps={{
                  propsDropdownList: {
                    className: styles.dropdown,
                  },
                }}
                size={'medium'}
              />
            </TitledRow>
            <TitledRow
              title={'Installation'}
              label={'Latest Salesmsg Agentforce package to be installed'}
            >
              <Button
                className={'noTextDecoration'}
                tag='a'
                target='_blank'
                rel='noreferrer'
                text='Download'
                typeBtn='contained'
                contained='secondary'
                size='large'
                href={installUrl}
                disabled={!installUrl}
              />
            </TitledRow>
          </div>
        </CollapseWithIcon>
      </div>
    )
  }
)
